<template>
    <EpharmaTemplate>
        <template #page_title>RETOURS AUX FOURNISSEURS</template>
        <template #page_counter>
            <i class="fas fa-database"></i> {{ lines }}
        </template>
        <template #content>
            <div class="bg-white row border shadow-md rounded p-1 mb-3 mx-auto d-flex align-items-center">
                <div class="col-md-8">
                    <p class="mb-3"><small>Rechercher par date ou fournisseur</small></p>
                    <form @submit.prevent="periodFilter" class="form-row">
                        <div class="col-md">
                            <input class="form-control form-control-sm border border-dark px-[4rem]" type="date"
                                v-model="filterForm.debut">
                        </div>
                        <div class="col-md">
                            <input class="form-control form-control-sm border border-dark px-[4rem]" type="date"
                                v-model="filterForm.fin">
                        </div>
                        <div class="col-md">
                            <select class="form-control border border-dark px-[4rem] h-75"
                                v-model="filterForm.fournisseur_libelle" >
                                <option disabled :value="null">Selection du fournisseur</option>
                                <option v-for="fournisseur in fournisseurs" :key="fournisseur.libelle"
                                    :value="fournisseur">
                                    {{ fournisseur.libelle }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <button type="submit" class="btn">
                                <i class="fa-solid fa-circle-check text-success" style="font-size: 1.6rem;"
                                    title="Appliquer le filtrage"></i>
                            </button>
                            <button type="button" class="btn" @click="removeFilter">
                                <i class="fa-solid fa-circle-minus" style="font-size: 1.6rem; color: #28a745;"
                                    title="Annuler le filtrage"></i>
                            </button>
                        </div>
                    </form>
                </div>

                <div class="col-md-4">
                    <p class="mb-3"><small>Rechercher par mots clés</small></p>
                    <searchByKeyword class="mb-3" v-on:set-keyword-filter="searchLines" />
                </div>
            </div>
            <AsdecodeTable :key="key" :url="url" :columns="columns" :table="table" :newKeyWord="keyWord"
                v-on:set-total-records="updateLines">
                <template #action_btns=slotProps>
                    <button class="btn btn-sm btn-light m-1" @click="openEditModal(slotProps.data)">
                        <i class="fas fa-edit"></i>
                    </button>
                </template>
            </AsdecodeTable>
        </template>
    </EpharmaTemplate>
</template>
<script>
import { defineComponent, defineAsyncComponent } from 'vue';
const ShowRetour = defineAsyncComponent(() => import('./ShowRetour.vue'));

export default defineComponent({
    data() {
        return {
            key: 1,
            table: 'retour_fournisseurs',
            lines: 0,
            keyWord: '',
            columns: [
                {
                    key: 'libelle',
                    label: 'PRODUIT',
                    exportable: true
                },
                {
                    key: 'qte',
                    label: 'QTE PRODUIT',
                    exportable: true
                },
                {
                    key: 'montant',
                    label: 'VALEUR',
                    format: 'money',
                    exportable: true
                },
                {
                    key: 'created_at',
                    label: 'DATE',
                    format: 'date',
                    exportable: true
                },
                {
                    key: 'fournisseur',
                    label: 'FOURNISSEUR',
                    exportable: true
                },
                {
                    key: 'statut',
                    label: 'STATUT',
                    exportable: true
                }
            ],
            defaultUrl: '/api/retour_fournisseurs',
            url: '/api/retour_fournisseurs',
            filterForm: {
                fournisseur_libelle: null
            },
            fournisseurs: [],
        };
    },
    mounted() {
        this.getFournisseurs()
    },
    methods: {
        //recuperer la liste des fournisseurs
        getFournisseurs() {
            this.isLoading = true
            this.axios.get('/api/fournisseurs').then(response => {
                this.fournisseurs = response.data.data
                this.isLoading = false
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        searchLines(keyword) {
            this.keyWord = keyword;
            this.key++
        },
        updateLines(total) {
            this.lines = total;
        },
        openEditModal(objData) {
            this.$dialog.open(ShowRetour, {
                props: {
                    header: "Retour aux fournisseur #"+objData.id,
                    style: {
                        width: '50vw',
                    },
                    modal: true
                },
                data: objData
            });
        },
        //filtre par periode
        periodFilter() {
            let newUrl = this.defaultUrl;

            let dateDebut = new Date(this.filterForm.debut);
            let dateFin = new Date(this.filterForm.fin);

            // Validation des dates
            if (this.filterForm.debut && this.filterForm.fin && dateFin < dateDebut) {
                this.filterForm.debut = null;
                this.filterForm.fin = null;

                this.$toast.add({
                    severity: 'warn',
                    summary: 'Oups !',
                    detail: 'La date de fin ne peut pas être antérieure à la date de début.',
                    life: 7000
                });
                return;
            }

            // Ajout des paramètres de date
            if (this.filterForm.debut) {
                newUrl = $checkUrlFormat(newUrl) + 'period_from=' + this.filterForm.debut;
            }

            if (this.filterForm.fin) {
                newUrl = $checkUrlFormat(newUrl) + 'period_to=' + this.filterForm.fin;
            }

            // Ajout du paramètre fournisseur
            if (this.filterForm.fournisseur_libelle && this.filterForm.fournisseur_libelle.libelle) {
                newUrl = $checkUrlFormat(newUrl) + 'fournisseur_libelle=' + encodeURIComponent(this.filterForm.fournisseur_libelle.libelle);
            }

            this.url = newUrl;
            this.key++;
        },
    }
});
</script>